import { BlockErrorMessage } from '../../../Block/BlockErrorMessage';
import { ButtonBase } from '../../../Button/ButtonBase';
import { FormListInputAndText } from '../../../Form/FormList/FormListInputAndText';
import { InputText } from '../../../Form/InputText';
import { InnerButtonArea } from '../../../Layout/InnerLayout/InnerButtonArea';
import { InnerMargin } from '../../../Layout/InnerLayout/InnerMargin';
import { TableBody } from '../../../Table/TableBody';
import { TableTrFormLabel } from '../../../Table/TableTr/TableTrFromLabel';

import type { InvalidParam } from '../../../../types/InvalidParam';
import type { FC, ChangeEventHandler, FormEventHandler } from 'react';

export type PasswordResetInvalidParam = InvalidParam & {
  name: 'email';
};

export type PasswordResetInvalidParams = PasswordResetInvalidParam[];

export type PasswordResetApplyContentsProps = {
  invalidParams?: PasswordResetInvalidParams;
  disableSubmitButton?: boolean;
  errorMessage?: string;
  eventHandlers?: {
    changeEmail: ChangeEventHandler<HTMLInputElement>;
    submit: FormEventHandler<HTMLFormElement>;
  };
};

export const PasswordResetApplyContents: FC<
  PasswordResetApplyContentsProps
> = ({ invalidParams, disableSubmitButton, errorMessage, eventHandlers }) => {
  const emailError = invalidParams?.find((value) => value.name === 'email');

  return (
    <form method="post" onSubmit={eventHandlers?.submit}>
      <TableBody>
        <TableTrFormLabel
          id="email"
          required={true}
          errorMessage={emailError?.reason ? emailError?.reason : ''}
          title="登録しているメールアドレス"
        >
          <FormListInputAndText text="※受信拒否設定をしている方は、「nurse-senka.jp」からの受信を許可してください。">
            <InputText
              name="email"
              id="email"
              type="email"
              width="default"
              placeholder="例)example@nurse-senka.jp"
              onChange={eventHandlers?.changeEmail}
            />
          </FormListInputAndText>
        </TableTrFormLabel>
      </TableBody>
      {errorMessage ? (
        <BlockErrorMessage>{errorMessage}</BlockErrorMessage>
      ) : (
        ''
      )}
      <InnerButtonArea>
        <InnerMargin align="center">
          <ButtonBase
            color="primary"
            width="extend"
            disable={disableSubmitButton === true}
          >
            確認メールを送信
          </ButtonBase>
        </InnerMargin>
      </InnerButtonArea>
    </form>
  );
};
